import { getCookie } from '@jspartials/cookie-utils';

const testAbCookieName = 'TEST_AB';
const testAbSegmentName = 'segment_A';

const clearProductTiles = () => {
  const testAbCookieValue = getCookie(testAbCookieName);
  const skusList = globalVariables.testAb.skusList || [];

  if (testAbCookieValue === testAbSegmentName) {
    skusList.forEach(function (sku) {
      const testAbTileElement =
        document.querySelector('.gtm-product-tile[data-pid="' + sku + '"]') ||
        null;
      const testAbVariantTileElement =
        document.querySelector(
          '.gtm-product-tile__variants-list-item[data-pid="' + sku + '"]'
        ) || null;

      if (testAbTileElement) {
        testAbTileElement.parentElement.remove();
      }

      if (testAbVariantTileElement) {
        testAbVariantTileElement.remove();
      }
    });
  }
};

const productIsInTest = (productId) => {
  const skusList = globalVariables.testAb.skusList || [];
  return skusList.indexOf(productId) !== -1;
};

const updateAddToCartButton = () => {
  const testAbCookieValue = getCookie(testAbCookieName);
  const cta = globalVariables.testAb.cta;
  const testAbAddToCartButton =
    document.querySelector('.js-button-add-to-cart') || null;
  const testAbCurrentSku = testAbAddToCartButton
    ? testAbAddToCartButton.getAttribute('data-pid')
    : '';
  const testAbAddToCartButtonText = testAbAddToCartButton
    ? testAbAddToCartButton.querySelector('.js-button-add-to-cart__text')
    : null;
  const testAbAddToCartButtonIsDisabled = testAbAddToCartButton
    ? testAbAddToCartButton.disabled
    : false;

  if (productIsInTest(testAbCurrentSku)) {
    if (testAbCookieValue === testAbSegmentName) {
      if (!testAbAddToCartButtonIsDisabled) {
        testAbAddToCartButton.setAttribute('disabled', true);
        testAbAddToCartButton.style.pointerEvents = 'none';

        if (testAbAddToCartButtonText) {
          testAbAddToCartButtonText.textContent = cta.soldOut;
        }
      }
    } else {
      if (testAbAddToCartButtonIsDisabled) {
        testAbAddToCartButton.removeAttribute('disabled');
        testAbAddToCartButton.style.pointerEvents = 'auto';

        if (testAbAddToCartButtonText) {
          testAbAddToCartButtonText.textContent = cta.addToCart;
        }
      }
    }
  }
};

export { clearProductTiles, updateAddToCartButton };
